import { render, staticRenderFns } from "./LmTagsInputBuilderUi.vue?vue&type=template&id=79c4a86f&"
import script from "./LmTagsInputBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmTagsInputBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports